import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { APIService, KPI } from '../api';
import { UtilsService } from './utils.service';

@Injectable()
export class SiteService {

  private _contracts$: Observable<KPI.EnergyContract[]>;
  private _counters$: Observable<KPI.EnergyCounter[]>;

  constructor(
    private api: APIService,
  ) { }

  public get contracts$(): Observable<KPI.EnergyContract[]> {
    if (!this._contracts$) {
      this._contracts$ = this.api.get_site_contracts();
    }

    return this._contracts$;
  }

  public get counters$(): Observable<KPI.EnergyCounter[]> {
    if (!this._counters$) {
      this._counters$ = this.api.get_site_counters([]);
    }

    return this._counters$;
  }

  private monthlyEnergyData: { [key: string]: Observable<KPI.EnergyData> } = {};
  public getEnergyDataMonthly(perimeters: Number[], year?: Number, start_date?: string, end_date?: string): Observable<KPI.EnergyData> {
    const key = UtilsService.getKey(arguments);
    if (!this.monthlyEnergyData[key]) {
      let body = {
        perimeter: perimeters,
        year: year,
        start_date,
        end_date,
      }
      this.monthlyEnergyData[key] = this.api.get_site_energy_data_monthly(body).pipe(shareReplay(1));
    }
    return this.monthlyEnergyData[key]
  }

  public getEnergyDataCorrectedMonthly(perimeter: number[], year: number, start_date?: string, end_date?: string): Observable<KPI.EnergyDataCorrected> {
    let body = {
      perimeter: perimeter,
      year: year,
      start_date,
      end_date,
    }
    return this.api.get_site_energy_data_corrected_monthly(body);
  }

  private monthlyEmissions: { [key: string]: Observable<KPI.EnergyCarbonData> } = {};
  public getEmissionMonthly(perimeter: number[], year: number, start_date?: string, end_date?: string): Observable<KPI.EnergyCarbonData> {
    const key = UtilsService.getKey(arguments);
    if (!this.monthlyEmissions[key]) {
      let body = {
        perimeter: perimeter,
        year: year,
        start_date,
        end_date,
      }
      this.monthlyEmissions[key] = this.api.get_site_energy_emission_data_monthly(body).pipe(shareReplay(1));
    }
    return this.monthlyEmissions[key];
  }

}
